var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5234 91.9044C27.7394 91.9044 9.14062 73.2872 9.14062 50.522C9.14062 27.738 27.7582 9.13916 50.5234 9.13916C73.3074 9.13916 91.9058 27.7568 91.9058 50.522C91.9058 73.306 73.3074 91.9044 50.5234 91.9044Z",
    fill: "url(#paint0_linear_4756_21486)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C22.5 100 0 77.5 0 50C0 22.5 22.5 0 50 0C77.5 0 100 22.5 100 50C100 77.5 77.5 100 50 100ZM50 11.1176C28.6176 11.1176 11.1176 28.6176 11.1176 50C11.1176 71.3824 28.6176 88.8824 50 88.8824C71.3824 88.8824 88.8824 71.3824 88.8824 50C88.8824 28.6176 71.3824 11.1176 50 11.1176Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8432 63.5434H70.51V74.377H57.726V83.5434H46.6084V74.661H33.2752C33.2752 71.0434 32.726 67.445 33.5592 64.1118C33.8432 62.445 35.7752 60.7782 37.1764 59.1118C41.3432 54.1118 45.51 49.1118 49.9608 44.1118C51.6272 42.161 53.294 40.4942 55.2448 38.2786H34.4116V27.445H46.6272V18.2798H57.4608V27.1598H70.794C70.794 30.777 71.3432 34.3758 70.51 37.709C70.226 39.3758 68.294 41.0422 66.8924 42.709C62.726 47.709 58.5592 52.709 54.1084 57.709C52.4412 59.661 50.7752 61.5926 48.8432 63.5434Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4756_21486",
    x1: 22.1093,
    y1: 78.899,
    x2: 79.2369,
    y2: 21.7714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCE58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZec);
export default __webpack_public_path__ + "static/media/ZEC.a29afef50b97d2d39c6853d8beae3dc0.svg";
export { ForwardRef as ReactComponent };